import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

/**
 * Reusable labelled slider: a header row (label + optional value display) above
 * a Slider wired with consistent ARIA attributes, plus an optional row of
 * captions underneath. Removes the repeated slider boilerplate across the
 * calculator inputs (company profile, implementation approach, maturity).
 */
export function LabeledSlider({
  label,
  value,
  onValueChange,
  min,
  max,
  step = 1,
  display = null,
  ariaLabel,
  testId,
  captions = null,
  labelClassName = 'text-[#66707A] text-sm',
  sliderClassName = 'mt-2',
  captionClassName = 'mt-1',
}) {
  return (
    <div>
      <div className="flex flex-wrap justify-between items-center gap-2">
        <Label className={labelClassName}>{label}</Label>
        {display}
      </div>
      <Slider
        value={[value]}
        onValueChange={([v]) => onValueChange(v)}
        min={min}
        max={max}
        step={step}
        className={sliderClassName}
        data-testid={testId}
        aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
      />
      {captions && (
        <div className={`grid grid-flow-col auto-cols-fr gap-2 text-xs text-[#8A929B] ${captionClassName}`}>
          {captions.map((c, index) => (
            <span key={c} className="min-w-0 text-center first:text-left last:text-right [overflow-wrap:anywhere]"
                  data-testid={`${testId}-caption-${index}`}>{c}</span>
          ))}
        </div>
      )}
    </div>
  );
}
